<template>
  <block title="场馆探查">
    <h3 style="text-align: center;">{{zhanhui.jbcg}}同期展会</h3>
    <el-timeline>
      <el-timeline-item
          v-for="(activity, index) in data"
          :key="index"
          :timestamp="activity.jbkssj" hide-timestamp>
        <div class="timeline-content">
          <span style="flex: none;margin-right: 10px;">{{activity.jbkssj}}</span>
          <span style="flex: none;margin-right: 10px;">{{ activity.zhmj }}㎡</span>
          <a class="link" :href="$router.resolve({path: (activity.abroad==true?'/zhanhui/abroad-details':'/zhanhui/details'),query:{id:activity.id}}).href" style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{ activity.zhmc }}</a>
        </div>
      </el-timeline-item>
    </el-timeline>
  </block>
</template>

<script>
import api from "../api";
import Block from "./Block";

export default {
  name: "ZhanhuiCgtcBlock",
  components: {Block},
  props: {
    zhanhui: Object
  },
  data() {
    return {
      data: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.data = (await api.listZhanhui({
        jbcg: this.zhanhui.jbcg,
        page: 0,
        size: 10,
        sort: 'jbkssj,DESC'
      })).data.content
    }
  }
}
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
